import { useUserStore } from "../store/userStore";

export function useIsMonitor() {
  const user = useUserStore((state) => state.user);

  const isMonitor = localStorage.getItem("userRole") === "monitor";
  const devices = user?.available_devices;

  return {
    isMonitor,
    canEdit: isMonitor,
    isDisabled: !isMonitor,
    devices,
  };
}

export default useIsMonitor;
